import { useState, useEffect } from "react";
import { FaExpand, FaCompress } from "react-icons/fa";
import { RiMenu2Line, RiMenu3Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from '../Images/Subtract.png';

const Navbar = ({ setIsCollapsed, isCollapsed, isMobile }) => {
  const navigate = useNavigate();
  const [redemptionCount, setRedemptionCount] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const fetchRedemptionRequests = async () => {
      try {
        const response = await axios.get(
          "https://api.editezy.com/api/admin/getredemption-requests"
        );
        setRedemptionCount(response.data.requests?.length || 0);
      } catch (error) {
        console.error("Error fetching redemption requests:", error);
      }
    };
    fetchRedemptionRequests();
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  const handleToggleSidebar = () => {
    if (typeof setIsCollapsed === "function") {
      setIsCollapsed((prev) => !prev);
    }
  };

  return (
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        flexShrink: 0,
        backgroundImage: "url('https://img.freepik.com/free-photo/hand-painted-watercolor-background-with-sky-clouds-shape_24972-1095.jpg?t=st=1746429807~exp=1746433407~hmac=e3434110c0769d2ad42bd54e0534379335887da5831a723df88f4f74891e28d2&w=1380')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderBottom: "1px solid rgba(255,255,255,0.2)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
        minHeight: "56px",
      }}
    >
      {/* Glassmorphism overlay */}
      <div style={{
        position: "absolute",
        inset: 0,
        background: "rgba(0,0,0,0.3)",
        backdropFilter: "blur(10px)",
        pointerEvents: "none",
      }} />

      <div style={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 12px",
        height: "56px",
        gap: "8px",
      }}>
        {/* Hamburger */}
        <button
          onClick={handleToggleSidebar}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "6px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            transition: "background 0.2s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
          onMouseLeave={e => e.currentTarget.style.background = "none"}
        >
          {isCollapsed
            ? <RiMenu2Line style={{ fontSize: "22px", color: "rgba(255,255,255,0.9)" }} />
            : <RiMenu3Line style={{ fontSize: "22px", color: "rgba(255,255,255,0.9)" }} />
          }
        </button>

        {/* Right controls */}
        <div style={{ display: "flex", alignItems: "center", gap: isMobile ? "8px" : "12px" }}>

          {/* Redemption button */}
          <button
            onClick={() => navigate("/redemptions")}
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: isMobile ? "6px 10px" : "7px 14px",
              background: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "10px",
              color: "#fff",
              fontSize: isMobile ? "11px" : "13px",
              fontWeight: 500,
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "background 0.2s, transform 0.2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.2)"; e.currentTarget.style.transform = "scale(1.04)"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.12)"; e.currentTarget.style.transform = "scale(1)"; }}
          >
            {isMobile ? "Redeem" : "Redemption Requests"}
            {redemptionCount > 0 && (
              <span style={{
                position: "absolute",
                top: "-8px",
                right: "-8px",
                background: "#ef4444",
                color: "#fff",
                borderRadius: "50%",
                width: "18px",
                height: "18px",
                fontSize: "10px",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(239,68,68,0.6)",
                animation: "pulse 1.5s infinite",
              }}>
                {redemptionCount}
              </span>
            )}
          </button>

          {/* Fullscreen — desktop only */}
          {!isMobile && (
            <button
              onClick={toggleFullscreen}
              title="Toggle Fullscreen"
              style={{
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "50%",
                width: "36px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                color: "#fff",
                fontSize: "14px",
                flexShrink: 0,
                transition: "background 0.2s, transform 0.2s",
              }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.2)"; e.currentTarget.style.transform = "scale(1.1)"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.1)"; e.currentTarget.style.transform = "scale(1)"; }}
            >
              {isFullscreen ? <FaCompress /> : <FaExpand />}
            </button>
          )}

          {/* Logo */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", flexShrink: 0 }}>
            <img
              src={logo}
              alt="EDITEZY Logo"
              style={{
                objectFit: "cover",
                width: isMobile ? "34px" : "clamp(34px, 3vw, 44px)",
                height: isMobile ? "34px" : "clamp(34px, 3vw, 44px)",
              }}
            />
            <span style={{ color: "rgba(255,255,255,0.9)", fontSize: "9px", fontWeight: 600, letterSpacing: "0.08em", marginTop: "2px" }}>
              EDITEZY
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;